module.exports = __webpack_public_path__ + "img/common-loon.a70c7bc6.jpg";